import { CloudActions } from '@portal/portal-core';
import * as Types from '../types';

interface AgreementsState {
  isEulaAgreed?: boolean;
  agreementId?: string;
  [key: string]: unknown;
}

interface AgreementsAction {
  type: string;
  data?: unknown;
  isEulaAgreed?: boolean;
}

const initialState: AgreementsState = { isEulaAgreed: false };

export function userAgreements(
  state: AgreementsState = initialState,
  action: AgreementsAction,
): AgreementsState {
  switch (action.type) {
    case Types.CLIENT_USER_AGREEMENT_STOWE:
      return { ...state, ...(action.data as Record<string, unknown>) };
    case Types.CLIENT_USER_HAS_NOT_AGREED_YET:
      return {
        ...state,
        agreementId: action.data as string,
        isEulaAgreed: action.isEulaAgreed,
      };
    case Types.CLIENT_USER_HAS_AGREED:
      return {
        ...state,
        agreementId: action.data as string,
        isEulaAgreed: action.isEulaAgreed,
      };
    case CloudActions.LOGOUT:
      return {};
    default:
      return state;
  }
}
